import React from "react";
import { format } from "date-fns";
import "./style.css";
import ReadMore from "../../../../features/ReadMore";
import SeansList from "../MovieDetails/SeansList";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { Exercise } from "../../../models/Exercise";
import LoadableComponent from "../../../../features/Loading/LoadableComponent";
import { ShowSave } from "../../../models/ShowSave";
import { useTranslation } from "react-i18next";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";

interface IProps {
  loading: boolean;
  date: Date;
  movieList: ShowSave[];
}

const seansView = (isDesktop: boolean, date: Date, exerciseList: Exercise[], locale: Locale | undefined) => {
  return (
    <React.Fragment>
      <p>{format(date, "EEEE dd.MM", { locale: locale })}:</p>
      <SeansList exerciseList={exerciseList} width={isDesktop ? "15%" : "30%"} />
    </React.Fragment>
  );
};

const CinemaRepertoire: React.FC<IProps> = ({ date, loading, movieList }: IProps) => {
  const locale = useLocaleByLanguage();
  const isDesktop = useDesktopSize();
  const imgProps = {
    width: isDesktop ? 120 : 100,
    height: isDesktop ? 180 : 150,
  };

  return (
    <LoadableComponent loading={loading}>
      {movieList.map((item, index) => (
        <div key={index} className={isDesktop ? "repertoire-wrapper" : "repertoire-wrapper-mobile"}>
          <div className={"repertoire-poster"}>
            <img src={item.moviePicture} alt={"poster"} width={imgProps.width} height={imgProps.height} />
          </div>
          <div className={"repertoire-details"}>
            <h3>{item.name}</h3>
            <p>{`${item.type} | ${item.duration}`}</p>
            {/* <ReadMore text={item.description} minLengthText={isDesktop ? 200 : 100} /> */}

            {isDesktop && seansView(isDesktop, date, item.exercises, locale)}
          </div>
          {!isDesktop && (
            <div className={"repertoire-buttons-panel"}>{seansView(isDesktop, date, item.exercises, locale)}</div>
          )}
        </div>
      ))}
    </LoadableComponent>
  );
};

export default CinemaRepertoire;
